import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ProduktService } from "../produkt.service";
import { ProduktDetailHeaderComponent } from "./produkt-detail-header/produkt-detail-header.component";
import { ProduktDetailProduktspecifikationComponent } from "./produkt-detail-produktspecifikation/produkt-detail-produktspecifikation.component";
import { ProduktDetailComponent } from "./produkt-detail.component";
import { ProduktDetailBasComponent } from "./tabs/produkt-detail-bas/produkt-detail-bas.component";
import { MatrisComponent } from "./tabs/produkt-detail-fordelningsmatris/matris/matris.component";

import {
    FordelningsmatrisDiameterfordelningModalComponent
} from "./tabs/produkt-detail-fordelningsmatris/matris/modals/diameterfordelning-modal/diameterfordelning-modal.component";
import { FordelningsmatrisLangdmodulModalComponent } from "./tabs/produkt-detail-fordelningsmatris/matris/modals/langdmodul-modal/langdmodul-modal.component";
import { ProduktDetailFordelningsmatrisComponent } from "./tabs/produkt-detail-fordelningsmatris/produkt-detail-fordelningsmatris.component";
import { ProduktDetailProduktinstruktionerComponent } from "./tabs/produkt-detail-produktinstruktioner/produkt-detail-produktinstruktioner.component";

import {
    ProduktDetailUppfoljningProduktlarmComponent
} from "./tabs/produkt-detail-uppfoljning/produkt-detail-uppfoljning-produktlarm/produkt-detail-uppfoljning-produktlarm.component";
import { ProduktDetailUppfoljningComponent } from "./tabs/produkt-detail-uppfoljning/produkt-detail-uppfoljning.component";

@NgModule({
    imports: [
        RaskCommonModule,
        NgSelectModule,
        ProduktDetailComponent,
        ProduktDetailHeaderComponent,
        ProduktDetailBasComponent,
        ProduktDetailFordelningsmatrisComponent,
        ProduktDetailUppfoljningComponent,
        ProduktDetailUppfoljningProduktlarmComponent,
        ProduktDetailProduktinstruktionerComponent,
        MatrisComponent,
        FordelningsmatrisLangdmodulModalComponent,
        FordelningsmatrisDiameterfordelningModalComponent,
        ProduktDetailProduktspecifikationComponent
    ],
    providers: [ProduktService]
})
export class ProduktDetailModule { }
